// extracted by mini-css-extract-plugin
export default {"linksBox":"legalLinks_linksBox__nKdMr"};